import { Box, Divider } from '@chakra-ui/react'
import { depressionScreeningField } from '@hb/shared'
import { useEffect } from 'react'
import { useField, useForm } from 'react-final-form'
import { FormElement } from '../../../../components/forms/Input'
import { SectionLabel } from '../../SectionLabel'

const CLINICAL_THRESHOLD = 10

const getInterpretation = (tool: string | undefined, score: number): string => {
  const toolName = tool ?? 'Screening'
  const elevated = score >= CLINICAL_THRESHOLD
  return `${toolName} score ${score} — ${elevated ? 'elevated. Clinical follow-up indicated.' : 'within normal range.'}`
}

const InterpretationAutofill = () => {
  const form = useForm()
  const {
    input: { value: tool },
  } = useField<string | undefined>('data.depressionScreening.tool', {
    subscription: { value: true },
  })
  const {
    input: { value: score },
  } = useField<number | undefined>('data.depressionScreening.score', {
    subscription: { value: true },
  })
  const {
    input: { value: currentInterpretation },
  } = useField<string | undefined>('data.depressionScreening.interpretation', {
    subscription: { value: true },
  })

  useEffect(() => {
    if (typeof score !== 'number') return
    // Only auto-fill when blank — preserve provider edits.
    if (!currentInterpretation) {
      form.change('data.depressionScreening.interpretation', getInterpretation(tool, score))
    }
  }, [tool, score]) // eslint-disable-line react-hooks/exhaustive-deps

  return null
}

export const DepressionScreeningInput = () => (
  <Box px={4} py={3} w="100%" data-child-name="data.depressionScreening">
    <SectionLabel mb={1}>Depression &amp; Anxiety Screening</SectionLabel>
    <Divider mb={2} />
    <InterpretationAutofill />
    <FormElement
      root
      showName={false}
      field={depressionScreeningField}
      name="data.depressionScreening"
    />
  </Box>
)
